export const BLACK = "#000000";
export const BLUE = "#3477db";
export const FUCHSIA = "#9448bc";
export const GREEN = "#008000";
export const GREY = "#f0f0f0";
export const GREY_DARK = "#4d4d4d";
export const VALENCIA = "#d64541";
export const WHITE = "#ffffff";
